var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    { staticClass: "app-header" },
    [
      _c(
        "div",
        { staticClass: "menu-buttons" },
        [
          !_vm.hideMenuToggle
            ? _c("show-at", { attrs: { breakpoint: "small" } }, [
                _c("img", {
                  staticClass: "menu-icon toggle-button",
                  attrs: { src: require("@/assets/ic-menu.svg") },
                  on: { click: _vm.toggleMenu }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "logo-container",
              attrs: { to: { name: "authenticated" } }
            },
            [_c("img", { attrs: { src: _vm.logoUrl, alt: "Home" } })]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header-content" },
        [
          _c("user-drop-menu"),
          _vm._v(" "),
          _c("div", {
            ref: "notificationButton",
            staticClass: "notification-button",
            class: { unread: Boolean(_vm.unread) },
            on: { click: _vm.notificationButtonClicked }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("app-notifications", {
        ref: "notificationsNode",
        class: { opened: _vm.notificationsOpened },
        attrs: { opened: _vm.notificationsOpened }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }